import React, { useEffect } from "react";
import { getToken } from "./api-server/usertoken";
import Emitter from "../utils/emitter";

const LoginSuccess = (props: any) => {
	const redirect = () => {
		if (localStorage.getItem("redirectURL")) {
			let url: any = localStorage.getItem("redirectURL") || "";
			localStorage.removeItem("redirectURL");
			let split = url.split("/");
			if (split[1] === import.meta.env.VITE_CLIENT_TENANT_ID) {
				window.location.href = url;
			} else {
				window.location.href = `/dashboard`;
			}
		} else {
			window.location.href = `/dashboard`;
		}
	};

	useEffect(() => {
		getToken()
			.then(async (res: any) => {
				// A fresh sign-in starts in the tenant remembered on the server,
				// not the one this browser was last on.
				localStorage.removeItem("currentTenantKey");
				redirect();
				// await this.props.dispatch({
				// 	type: "LOGIN_REGISTER",
				// 	payload: res.data,
				// });
				// await this.props.dispatch({ type: "LOGIN", payload: {} });
				// const sso_token = {
				// 	idToken: res.data?.idToken,
				// 	accessToken: res.data?.accessToken,
				// };
				// if (sso_token.idToken && sso_token.accessToken) {
				// 	await this.props.dispatch({
				// 		type: "SET_SSO_TOKEN",
				// 		payload: sso_token,
				// 	});
				// }
				// if (localStorage.getItem(`pbiToken`)) {
				// 	this.Redirect();
				// } else {
				// 	getPbiToken(res.data?.accessToken).then((result: any) => {
				// 		this.Redirect();
				// 	});
				// }
			})
			.catch(() => {
				// window.location.href = "/";
			});
	}, []);

	return <></>;
};

export default LoginSuccess;

// const mapStateToProps = (state: any) => {
// 	return {
// 		isLoggedIn: state.isLoggedIn,
// 		userToken: state.userToken,
// 		loginRegister: state.loginRegister,
// 	};
// };

// export default connect(mapStateToProps)(LoginSuccess);
